/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.0.9 Platform.gltf --transform
*/

import React, { useRef } from 'react';
import { useGLTF } from '@react-three/drei';

import PlatformModel from './Platform-transformed.glb';

export default function Model(props) {
	const { nodes, materials } = useGLTF(PlatformModel);
	const color = props.color;

	return (
		<group
			{...props}
			dispose={null}
			scale={100}
			rotation={[-Math.PI / 2, 0, 0]}
		>
			<mesh
				geometry={nodes.mesh0_mesh.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_1.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_2.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_3.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_4.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_5.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_6.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_7.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_8.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_9.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_10.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_11.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_12.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_13.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_14.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_15.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_16.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_17.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_18.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_19.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_20.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_21.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_22.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_23.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_24.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_25.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_26.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh0_mesh_27.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_1.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_2.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_3.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_4.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_5.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_6.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_7.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_8.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_9.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_10.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_11.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_12.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_13.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_14.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_15.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_16.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_17.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_18.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_19.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_20.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_21.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_22.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_23.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_24.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_25.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_26.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh28_mesh_27.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_1.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_2.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_3.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_4.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_5.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_6.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_7.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_8.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_9.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_10.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_11.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_12.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_13.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_14.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_15.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_16.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_17.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_18.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_19.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_20.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_21.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_22.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_23.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_24.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_25.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_26.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh56_mesh_27.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_1.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_2.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_3.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_4.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_5.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_6.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_7.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_8.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_9.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_10.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_11.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_12.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_13.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_14.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_15.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_16.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_17.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_18.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_19.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_20.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_21.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_22.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_23.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_24.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_25.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_26.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh84_mesh_27.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_1.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_2.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_3.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_4.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_5.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_6.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_7.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_8.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_9.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_10.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_11.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_12.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_13.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_14.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_15.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_16.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_17.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_18.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_19.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_20.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_21.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_22.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_23.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_24.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_25.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_26.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh112_mesh_27.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_1.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_2.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_3.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_4.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_5.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_6.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_7.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_8.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_9.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_10.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_11.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_12.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_13.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_14.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_15.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_16.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_17.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_18.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_19.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_20.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_21.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_22.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_23.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_24.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_25.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_26.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh140_mesh_27.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_1.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_2.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_3.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_4.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_5.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_6.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_7.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_8.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_9.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_10.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_11.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_12.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_13.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_14.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_15.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_16.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_17.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_18.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_19.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_20.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_21.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_22.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_23.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_24.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_25.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_26.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh168_mesh_27.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_1.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_2.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_3.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_4.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_5.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_6.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_7.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_8.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_9.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_10.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_11.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_12.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_13.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_14.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_15.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_16.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_17.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_18.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_19.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_20.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_21.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_22.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_23.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_24.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_25.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_26.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh196_mesh_27.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_1.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_2.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_3.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_4.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_5.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_6.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_7.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_8.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_9.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_10.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_11.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_12.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_13.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_14.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_15.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_16.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_17.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_18.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_19.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_20.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_21.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_22.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_23.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_24.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_25.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_26.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
			<mesh
				geometry={nodes.mesh224_mesh_27.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			>
				<meshLambertMaterial toneMapped={false} />
			</mesh>
		</group>
	);
}

useGLTF.preload('/Platform-transformed.glb');
